class SkinTone {
  constructor() {
    this.init();
  }
  clickEvent() {
    const skinTones = document.querySelectorAll('.skin-ton-main-wrapper');
    if (skinTones) {
      skinTones.forEach((skinTone) => {
        skinTone.classList.remove('skin-tone-active');
        skinTone.addEventListener('click', (event) => {
          event.stopPropagation()
          let skinData = skinTone.getAttribute('data-skin-ton').toLowerCase();
          const skinTonesWrapper = document.querySelectorAll('.product__color-swatch-wrap.skinton-js');
          skinTones.forEach((el) => el.classList.remove('skin-tone-active'));
          skinTone.classList.add('skin-tone-active');
          skinTonesWrapper.forEach((item) => {
            item.classList.remove('skin-ton-active');
          });
          skinTonesWrapper.forEach((item) => {
            const dataAttribute = item.getAttribute("data-skin-ton");
            if (dataAttribute) {
              const variantSkinData = JSON.parse(dataAttribute);
              if (variantSkinData.some(varianData => varianData.toLowerCase() === skinData)) {
                item.classList.add('skin-ton-active');
              }
            }
          });
          // const skinTonesWrapperactive = document.querySelectorAll('.product__color-swatch-wrap.skinton-js.skin-ton-active .product__color-swatch')
          // if (skinTonesWrapperactive) {
          //   if (skinTonesWrapperactive[0]) {
          //     skinTonesWrapperactive[0].click()
          //   }
          // }
        });

      });
    }
  }

  closeSharePopUp() {
    const sharebtn = document.querySelector(".close-product-copy-share")
    if (sharebtn) {
      sharebtn.addEventListener("click", () => {
        const desktopShare = document.querySelector(".social-share__button")
        desktopShare.click()
      })
    }
  }

  handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  thumbnailSection() {
    const thumbnails__items = document.querySelectorAll(".product-thumbnails .product-thumbnails__viewport .product-thumbnails__items")
    // Bundle swatches are excluded: their shade names never match a gallery/thumbnail group,
    // so this would hide the bundle's only (all-images) gallery.
    const swatchBtn = document.querySelectorAll(".product__color-swatches:not(.product__color-swatches--bundle):not(.product__color-swatches--bundle-static) .product__color-swatch-wrap")

    const mobileSlider = document.querySelectorAll(".product-media-mobile-slider")
    swatchBtn.forEach((ele) => {
      ele.addEventListener('click', () => {
        const swatch_title = ele.getAttribute("data-shade")
        swatchBtn.forEach((items) => items.classList.remove("selected"))
        const swatchTitle = this.handleize(swatch_title)
        thumbnails__items.forEach((item) => {
          const thumbnails__item = item.getAttribute("data-name")
          const thumbnailsItem = this.handleize(thumbnails__item)
          thumbnails__items.forEach((itm) => item.classList.remove("active"))
          if (thumbnailsItem === swatchTitle) {
            item.classList.add("active")
          }
        })
        if (mobileSlider.length > 0) {
          mobileSlider.forEach((item) => {
            const thumbnails__item = item.getAttribute("data-type")
            const thumbnailsItem = this.handleize(thumbnails__item)
            mobileSlider.forEach((itm) => item.classList.remove("active"))
            if (thumbnailsItem === swatchTitle) {
              item.classList.add("active")
              // Sliders are initialised on demand (see productImageSwiperMobile)
              this.initMobileSlider(item)
            }
          })
        }
        ele.classList.add("selected")
      })
    })

  }

  // Only the visible (.active) slider is initialised on load. There is one slider per
  // variant plus an "all" slider, all but one hidden, and creating 2 Swipers for each
  // of them was a large chunk of startup JS. The others are initialised when a shade
  // swatch makes them active (thumbnailSection).
  productImageSwiperMobile() {
    document.querySelectorAll('.product-media-mobile-slider.active').forEach((wrapper) => {
      this.initMobileSlider(wrapper)
    })
  }

  initMobileSlider(wrapper) {
    if (!wrapper || wrapper.dataset.swiperInit) return
    wrapper.dataset.swiperInit = 'true'
    // Thumbnail strip (visible on mobile when "Mobile gallery navigation" = Thumbnails):
    // fixed 64px squares set in main-product.css, so as many as fit are shown and the rest scroll
    var swiperThumbs = new Swiper(wrapper.querySelector(".swiper.product-thumbail-swiper"), {
      spaceBetween: 10,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      loopAdditionalSlides: 4,
    });


    // Dots under the mobile image slider; only rendered when "show_navigation_buttons" is enabled
    var paginationEl = wrapper.querySelector("[data-product-media-pagination]");

    new Swiper(wrapper.querySelector(".swiper.main-image-swapper"), {
      spaceBetween: 10,
      slidesPerView : 1,
      thumbs: {
        swiper: swiperThumbs,
      },
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
      } : false,
    });
    // No 'slideChange' sync from the thumbnail strip: scrolling the thumbnails must not change the main
    // image. Tapping a thumbnail is handled by the `thumbs` option above (Swiper slides the main image).
  }

  init() {
    this.clickEvent();
    this.closeSharePopUp()
    this.thumbnailSection()
    this.productImageSwiperMobile()
  }
}
new SkinTone();
